document.addEventListener("DOMContentLoaded", function () {
    // Initialize sort by dropdown with Choices.js on search page
    initializeSearchSortBy();

    // Initialize infinite scroll functionality
    initializeInfiniteScroll();

    function initializeSearchSortBy() {
        // Initialize desktop sort with Choices.js
        const sortBySelect = document.getElementById("SearchSortBy");
        if (sortBySelect) {
            const choices = new Choices(sortBySelect, {
                searchEnabled: false,
                itemSelectText: "",
                shouldSort: false,
                classNames: {
                    containerOuter: ["choices", "choices-fixed-width"],
                },
            });

            // When the sort by selection changes, redirect to the new URL
            sortBySelect.addEventListener("change", function () {
                const url = new URL(window.location.href);
                url.searchParams.set("sort_by", this.value);
                window.location.href = url.toString();
            });
        }

        // Initialize mobile sort drawer
        const mobileSortTrigger = document.querySelector(
            ".cs-plp-products__sort-mobile-trigger"
        );
        const mobileSortDrawer = document.querySelector(
            ".cs-plp-products__mobile-sort-drawer"
        );
        const mobileSortClose = document.querySelector(
            ".cs-plp-products__mobile-sort-close"
        );
        const mobileSortOverlay = document.querySelector(
            ".cs-plp-products__mobile-sort-overlay"
        );
        const mobileSortOptions = document.querySelectorAll(
            ".cs-plp-products__mobile-sort-option"
        );

        if (mobileSortTrigger && mobileSortDrawer) {
            // Open drawer on trigger click
            mobileSortTrigger.addEventListener("click", function () {
                mobileSortDrawer.classList.add("active");
                document.body.style.overflow = "hidden"; // Prevent background scrolling
            });

            // Close drawer functions
            const closeDrawer = function () {
                mobileSortDrawer.classList.remove("active");
                document.body.style.overflow = ""; // Re-enable scrolling
            };

            if (mobileSortClose) {
                mobileSortClose.addEventListener("click", closeDrawer);
            }

            if (mobileSortOverlay) {
                mobileSortOverlay.addEventListener("click", closeDrawer);
            }

            // Add click handlers for mobile sort options
            if (mobileSortOptions) {
                mobileSortOptions.forEach((option) => {
                    option.addEventListener("click", function () {
                        const value = this.getAttribute("data-value");

                        // Update URL and redirect
                        const url = new URL(window.location.href);
                        url.searchParams.set("sort_by", value);
                        window.location.href = url.toString();
                    });
                });
            }

            // Update the sort by label value on mobile
            const updateSortLabel = function () {
                const sortByLabel = document.querySelector(
                    ".cs-plp-products__sort-label-value"
                );
                if (sortByLabel) {
                    const sortBy =
                        new URLSearchParams(window.location.search).get(
                            "sort_by"
                        ) || document.querySelector("#SearchSortBy").value;
                    const selectedOption = document.querySelector(
                        `#SearchSortBy option[value="${sortBy}"]`
                    );
                    if (selectedOption) {
                        sortByLabel.textContent =
                            selectedOption.textContent.trim();
                    }
                }
            };

            // Update label on page load
            updateSortLabel();

            // Update label when sort changes (for when back button is used)
            window.addEventListener("popstate", updateSortLabel);
        }
    }

    function initializeInfiniteScroll() {
        let isLoading = false;
        let currentPage = 1;
        let hasMorePages = true;
        let currentTab = "products"; // Default tab

        // Get pagination info from the page
        const paginateInfo = getPaginateInfo();
        if (paginateInfo) {
            currentPage = paginateInfo.currentPage;
            hasMorePages = paginateInfo.hasMorePages;
        }

        // Update current tab when tabs are switched
        const tabButtons = document.querySelectorAll(".cs-search-tabs__tab");
        tabButtons.forEach((button) => {
            button.addEventListener("click", function () {
                currentTab = this.getAttribute("data-tab");
                // Reset pagination state when switching tabs
                currentPage = 1;
                hasMorePages = true;

                // Check if the current tab has any results
                const tabContent = document.querySelector(
                    `[data-tab-content="${currentTab}"]`
                );
                const hasResults =
                    tabContent &&
                    tabContent.querySelectorAll(".cs-plp-product-card__product")
                        .length > 0;

                if (!hasResults) {
                    // If no results in current tab, try to load the first page for this tab
                    loadNextPage();
                } else {
                    // Check pagination info for the current tab
                    const paginateInfo = getPaginateInfo();
                    if (paginateInfo) {
                        hasMorePages = paginateInfo.hasMorePages;
                    }
                }
            });
        });

        // Set initial active tab
        const activeTab = document.querySelector(
            ".cs-search-tabs__tab--active"
        );
        if (activeTab) {
            currentTab = activeTab.getAttribute("data-tab");
        }

        // Throttle function to limit scroll event frequency
        function throttle(func, limit) {
            let inThrottle;
            return function () {
                const args = arguments;
                const context = this;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    setTimeout(() => (inThrottle = false), limit);
                }
            };
        }

        // Check if user has scrolled to bottom
        function isNearBottom() {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Trigger when user is within 200px of the bottom
            return scrollTop + windowHeight >= documentHeight - 200;
        }

        // Load next page of results
        async function loadNextPage() {
            if (isLoading || !hasMorePages) return;

            isLoading = true;
            currentPage++;

            // Show loading indicator
            showLoadingIndicator();

            try {
                // Build the URL for the next page
                const url = new URL(window.location.href);
                url.searchParams.set("page", currentPage);

                // Fetch the next page
                const response = await fetch(url.toString());

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const html = await response.text();

                // Parse the HTML to extract new results
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Extract new results for the current tab
                const newResults = extractNewResults(doc, currentTab);

                if (newResults.length > 0) {
                    // Append new results to the current tab
                    appendResults(newResults, currentTab);

                    // Update pagination info
                    const newPaginateInfo = getPaginateInfoFromDoc(doc);
                    if (newPaginateInfo) {
                        hasMorePages = newPaginateInfo.hasMorePages;
                    }

                    // Update page title with new count
                    updatePageTitle();

                    // Show success feedback
                    showSuccessFeedback(newResults.length);
                } else {
                    // No more results for this tab
                    hasMorePages = false;
                    showNoMoreResultsFeedback();
                }
            } catch (error) {
                console.error("Error loading next page:", error);
                // Revert page number on error
                currentPage--;

                // Show error feedback
                showErrorFeedback();
            } finally {
                isLoading = false;
                hideLoadingIndicator();
            }
        }

        // Show success feedback when new results are loaded
        function showSuccessFeedback(resultCount) {
            let feedbackElement = document.querySelector(".cs-search-feedback");
            if (!feedbackElement) {
                feedbackElement = document.createElement("div");
                feedbackElement.className = "cs-search-feedback";
                feedbackElement.style.cssText = `
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #000;
                    color: #fff;
                    padding: 12px 20px;
                    border-radius: 4px;
                    font-family: 'ModernGothic-Regular', sans-serif;
                    font-size: 14px;
                    z-index: 1000;
                    opacity: 0;
                    transform: translateY(-20px);
                    transition: all 0.3s ease;
                `;
                document.body.appendChild(feedbackElement);
            }

            feedbackElement.textContent = `Loaded ${resultCount} more results`;
            feedbackElement.style.opacity = "1";
            feedbackElement.style.transform = "translateY(0)";

            // Hide after 3 seconds
            setTimeout(() => {
                feedbackElement.style.opacity = "0";
                feedbackElement.style.transform = "translateY(-20px)";
            }, 3000);
        }

        // Show feedback when no more results are available
        function showNoMoreResultsFeedback() {
            let feedbackElement = document.querySelector(".cs-search-feedback");
            if (!feedbackElement) {
                feedbackElement = document.createElement("div");
                feedbackElement.className = "cs-search-feedback";
                feedbackElement.style.cssText = `
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #6b6b6b;
                    color: #fff;
                    padding: 12px 20px;
                    border-radius: 4px;
                    font-family: 'ModernGothic-Regular', sans-serif;
                    font-size: 14px;
                    z-index: 1000;
                    opacity: 0;
                    transform: translateY(-20px);
                    transition: all 0.3s ease;
                `;
                document.body.appendChild(feedbackElement);
            }

            feedbackElement.textContent = "No more results available";
            feedbackElement.style.opacity = "1";
            feedbackElement.style.transform = "translateY(0)";

            // Hide after 3 seconds
            setTimeout(() => {
                feedbackElement.style.opacity = "0";
                feedbackElement.style.transform = "translateY(-20px)";
            }, 3000);
        }

        // Show error feedback
        function showErrorFeedback() {
            let feedbackElement = document.querySelector(".cs-search-feedback");
            if (!feedbackElement) {
                feedbackElement = document.createElement("div");
                feedbackElement.className = "cs-search-feedback";
                feedbackElement.style.cssText = `
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #dc3545;
                    color: #fff;
                    padding: 12px 20px;
                    border-radius: 4px;
                    font-family: 'ModernGothic-Regular', sans-serif;
                    font-size: 14px;
                    z-index: 1000;
                    opacity: 0;
                    transform: translateY(-20px);
                    transition: all 0.3s ease;
                `;
                document.body.appendChild(feedbackElement);
            }

            feedbackElement.textContent =
                "Error loading more results. Please try again.";
            feedbackElement.style.opacity = "1";
            feedbackElement.style.transform = "translateY(0)";

            // Hide after 5 seconds
            setTimeout(() => {
                feedbackElement.style.opacity = "0";
                feedbackElement.style.transform = "translateY(-20px)";
            }, 5000);
        }

        // Extract new results from the fetched HTML
        function extractNewResults(doc, tabType) {
            const results = [];

            if (tabType === "products") {
                const productCards = doc.querySelectorAll(
                    '[data-tab-content="products"] .cs-plp-product-card__product'
                );
                productCards.forEach((card) => {
                    // Check if this product is not already on the current page
                    const productId = card
                        .querySelector("[data-product-id]")
                        ?.getAttribute("data-product-id");
                    if (
                        productId &&
                        !document.querySelector(
                            `[data-product-id="${productId}"]`
                        )
                    ) {
                        results.push(card.outerHTML);
                    }
                });
            } else if (tabType === "articles") {
                const articleCards = doc.querySelectorAll(
                    '[data-tab-content="articles"] .cs-plp-product-card__product'
                );
                articleCards.forEach((card) => {
                    const articleUrl = card.querySelector("a")?.href;
                    if (
                        articleUrl &&
                        !document.querySelector(`a[href="${articleUrl}"]`)
                    ) {
                        results.push(card.outerHTML);
                    }
                });
            } else if (tabType === "pages") {
                const pageCards = doc.querySelectorAll(
                    '[data-tab-content="pages"] .cs-plp-product-card__product'
                );
                pageCards.forEach((card) => {
                    const pageUrl = card.querySelector("a")?.href;
                    if (
                        pageUrl &&
                        !document.querySelector(`a[href="${pageUrl}"]`)
                    ) {
                        results.push(card.outerHTML);
                    }
                });
            }

            return results;
        }

        // Append new results to the current tab
        function appendResults(newResults, tabType) {
            const tabContent = document.querySelector(
                `[data-tab-content="${tabType}"]`
            );
            if (tabContent) {
                newResults.forEach((resultHtml) => {
                    try {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = resultHtml;
                        const newElement = tempDiv.firstElementChild;
                        if (newElement) {
                            tabContent.appendChild(newElement);

                            // Re-initialize any interactive elements in the new content
                            initializeNewContent(newElement);
                        }
                    } catch (error) {
                        console.error("Error appending result:", error);
                    }
                });
            }
        }

        // Initialize any interactive elements in newly added content
        function initializeNewContent(element) {
            // Re-initialize any event listeners or interactive elements
            // This is a placeholder for any future interactive elements that might need initialization

            // Example: If you have any product form elements that need initialization
            const productForms = element.querySelectorAll(
                "form[data-product-form]"
            );
            productForms.forEach((form) => {
                // Re-initialize product form if needed
                if (window.initializeProductForm) {
                    window.initializeProductForm(form);
                }
            });
        }

        // Get pagination info from current page
        function getPaginateInfo() {
            // Look for pagination info in the page
            const paginateInfo = {
                currentPage: 1,
                hasMorePages: false,
            };

            // Check if there's a next page link or if we're not on the last page
            const nextPageLink = document.querySelector('a[href*="page="]');
            if (nextPageLink) {
                const url = new URL(nextPageLink.href);
                const pageParam = url.searchParams.get("page");
                if (pageParam) {
                    paginateInfo.currentPage = parseInt(pageParam) - 1;
                    paginateInfo.hasMorePages = true;
                }
            }

            // Also check if we have more than 250 results (the pagination limit)
            const totalResults = document.querySelectorAll(
                ".cs-plp-product-card__product"
            ).length;
            if (totalResults >= 250) {
                paginateInfo.hasMorePages = true;
            }

            return paginateInfo;
        }

        // Get pagination info from fetched document
        function getPaginateInfoFromDoc(doc) {
            const paginateInfo = {
                currentPage: currentPage,
                hasMorePages: false,
            };

            // Check if there's a next page link in the fetched content
            const nextPageLink = doc.querySelector('a[href*="page="]');
            if (nextPageLink) {
                const url = new URL(nextPageLink.href);
                const pageParam = url.searchParams.get("page");
                if (pageParam && parseInt(pageParam) > currentPage) {
                    paginateInfo.hasMorePages = true;
                }
            }

            // Also check if we got a full page of results (250 items)
            const newResults = doc.querySelectorAll(
                ".cs-plp-product-card__product"
            ).length;
            if (newResults >= 250) {
                paginateInfo.hasMorePages = true;
            }

            return paginateInfo;
        }

        // Show loading indicator
        function showLoadingIndicator() {
            let loadingIndicator = document.querySelector(
                ".cs-search-loading-indicator"
            );
            if (!loadingIndicator) {
                loadingIndicator = document.createElement("div");
                loadingIndicator.className = "cs-search-loading-indicator";
                loadingIndicator.innerHTML = `
          <div style="text-align: center; padding: 20px;">
            <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #000; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            <p style="margin-top: 10px; font-family: 'ModernGothic-Regular', sans-serif;">Loading more results...</p>
          </div>
        `;

                // Add CSS for spinner animation
                if (!document.querySelector("#cs-search-loading-styles")) {
                    const style = document.createElement("style");
                    style.id = "cs-search-loading-styles";
                    style.textContent = `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `;
                    document.head.appendChild(style);
                }

                // Append to the active tab content
                const activeTabContent = document.querySelector(
                    ".cs-search-tab-content--active"
                );
                if (activeTabContent) {
                    activeTabContent.appendChild(loadingIndicator);
                }
            }
            loadingIndicator.style.display = "block";
        }

        // Hide loading indicator
        function hideLoadingIndicator() {
            const loadingIndicator = document.querySelector(
                ".cs-search-loading-indicator"
            );
            if (loadingIndicator) {
                loadingIndicator.style.display = "none";
            }
        }

        // Update page title with new result count
        function updatePageTitle() {
            const searchTerm = new URLSearchParams(window.location.search).get(
                "q"
            );
            if (searchTerm) {
                const productElements = document.querySelectorAll(
                    '[data-tab-content="products"] .cs-plp-product-card__product'
                ).length;
                const articleElements = document.querySelectorAll(
                    '[data-tab-content="articles"] .cs-plp-product-card__product'
                ).length;
                const pageElements = document.querySelectorAll(
                    '[data-tab-content="pages"] .cs-plp-product-card__product'
                ).length;
                const totalResults =
                    productElements + articleElements + pageElements;

                if (totalResults > 0) {
                    document.title = `Search Results (${totalResults}) - ${searchTerm} | ${document.title
                        .split(" | ")
                        .pop()}`;
                }
            }
        }

        // Throttled scroll handler
        const throttledScrollHandler = throttle(() => {
            if (isNearBottom()) {
                loadNextPage();
            }
        }, 200);

        // Add scroll event listener
        window.addEventListener("scroll", throttledScrollHandler);

        // Also listen for scroll events on the document element for better compatibility
        document.addEventListener("scroll", throttledScrollHandler);
    }
});
